import { UserId } from '@app/icare/entities/user/schema/User'

import { entityId } from '@pkg/db/schema'
import { z } from 'zod'

import { PatientRelation } from './PatientRelation'

export const PatientCareManagerRole = {
  temporary: 'temporary',
  primary: 'primary',
}

export type PatientCareManagerRoleType = keyof typeof PatientCareManagerRole

export const PatientCareManagerId = entityId('patientCareManager')

export type PatientCareManagerIdType = typeof PatientCareManagerId.Type

export const PatientCareManagerRelationSchema = PatientRelation.extend({
  id: PatientCareManagerId.schema,
  toId: UserId.ref,
  role: z
    .enum(PatientCareManagerRole)
    .nullish()
    .default(() => PatientCareManagerRole.primary),
})

export type PatientCareManagerRelation = z.infer<typeof PatientCareManagerRelationSchema>
